import Dropdown from "stimulus-dropdown";
import { useTransition } from "stimulus-use";

export default class extends Dropdown {
  static targets = ["checkedPreview"];

  connect() {
    useTransition(this, {
      element: this.menuTarget,
      enterActive: "fade-enter-active",
      enterFrom: "fade-enter-from",
      enterTo: "fade-enter-to",
      leaveActive: "fade-leave-active",
      leaveFrom: "fade-leave-from",
      leaveTo: "fade-leave-to",
      hiddenClass: "d-none",
      // set this, because the item *starts* in an open state
      transitioned: false,
    });

    this.refreshPreview();
  }

  close() {
    this.leave();
  }

  open() {
    this.enter();
  }

  toggle() {
    this.toggleTransition();
  }

  refreshPreview() {
    this.checkedPreviewTarget.innerText = "";
    this.appendCheckedLabelsToButton();

    if(this.checkedPreviewTarget.children.length == 0){
      this.checkedPreviewTarget.innerText = this.checkedPreviewTarget.dataset.emptyLabel
    }
  }

  appendCheckedLabelsToButton() {
    for (let checkbox of this.menuTarget.querySelectorAll(
      'input[type="checkbox"]'
    )) {
      if (checkbox.checked) {
        let label = checkbox.labels[0].childNodes[0].cloneNode(true);
        this.checkedPreviewTarget.appendChild(label);
      }
    }
  }
}
